module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1005-59b8d62dc92aa1884b557706d770b68c.png";